module.exports = __webpack_public_path__ + "img/隨緣自強4.5 的副本.fd2ffecb.jpg";